module.exports = __webpack_public_path__ + "static/media/IndustryLeader005.51b19b9a.png";